import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const SendgridDomainAuthSchema = z
    .object({
        id: z.number(),
        user_id: z.number(),
        subdomain: z.string(),
        domain: z.string(),
        username: z.string(),
        ips: z.array(z.string()),
        custom_spf: z.boolean(),
        default: z.boolean(),
        legacy: z.boolean(),
        automatic_security: z.boolean(),
        valid: z.boolean(),
        dns: z.any(),
        validation_results: z.any().optional(),
    })
    .strict();

export class SendgridDomainAuth extends FromSchema(SendgridDomainAuthSchema) {
    id: number;
    user_id: number;
    subdomain: string;
    domain: string;
    username: string;
    ips: string[];
    custom_spf: boolean;
    default: boolean;
    legacy: boolean;
    automatic_security: boolean;
    valid: boolean;
    dns: object;
    validation_results?: object;
}
